import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=45fc8938&"
import script from "./UiInput.vue?vue&type=script&lang=js&"
export * from "./UiInput.vue?vue&type=script&lang=js&"
import style0 from "./UiInput.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/UiInput.vue
// module id = 1093
// module chunks = 0